function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import _each from 'lodash/each';
import React from 'react';
import PropTypes from 'prop-types';
import './SearchPage.css';
import L from 'leaflet';
import CountryLink, { CountryDropdown } from 'js/components/atoms/Link/country';
import Header from 'js/containers/organisms/Header';
import Footer from 'js/containers/organisms/Footer';
import datax from './data';
var data = datax();
export var COUNTRY_SEARCH_MAP_TILE_SOURCE = 'https://maps.wikimedia.org/osm-intl/{z}/{x}/{y}@2x.png';

var SearchPage =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SearchPage, _React$Component);

  function SearchPage(props) {
    var _this;

    _classCallCheck(this, SearchPage);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SearchPage).call(this, props));

    _this.shouldComponentUpdate = function (nextProps) {
      return false;
    };

    _this.state = {
      searchMapColorOverlays: []
    };
    return _this;
  }

  _createClass(SearchPage, [{
    key: "initializeSearchMap",
    value: function initializeSearchMap() {
      var _this2 = this;

      if (!this.props.countries) {
        return;
      }

      this.setState({
        searchMap: L.map(this.refs.countrySearchMap, {
          zoomControl: false,
          minZoom: 4
        })
      }, function () {
        _this2.state.searchMap.setView([12.6, -85.4], 5);

        _this2.state.searchMap.createPane('shapes');

        _this2.state.searchMap.getPane('shapes').style.zIndex = 900;

        _this2.state.searchMap.createPane('labels');

        _this2.state.searchMap.getPane('labels').style.zIndex = 901;
        L.tileLayer('http://{s}.basemaps.cartocdn.com/rastertiles/voyager_nolabels/{z}/{x}/{y}.png', {
          attribution: '©OpenStreetMap, ©CartoDB'
        }).addTo(_this2.state.searchMap);
        L.tileLayer('http://{s}.basemaps.cartocdn.com/rastertiles/voyager_labels_under/{z}/{x}/{y}.png', {
          attribution: '©OpenStreetMap, ©CartoDB'
        }).addTo(_this2.state.searchMap); // TODO: do we need this?

        _this2.updateCountryColorOverlays();
      });
    }
  }, {
    key: "updateCountryColorOverlays",
    value: function updateCountryColorOverlays() {
      var _this3 = this;

      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      if (!this.state.searchMap) return;
      var countryCodes = props.countries.map(function (a) {
        return a.properties.code;
      });
      if (!countryCodes || !countryCodes.length) return;

      if (this.state.searchMapColorOverlays.length) {
        _each(this.state.searchMapColorOverlays, function (overlay) {
          _this3.state.searchMap.removeLayer(overlay);
        });
      }

      _each(countryCodes, function () {
        data.layers.map(function (a) {
          var context = _this3;
          var style = a.properties.style;
          var searchMapColorOverlay = L.geoJson(a.properties.shape, {
            style: style,
            pane: 'shapes',
            onEachFeature: function onEachFeature(feature, featureLayer) {
              if (feature.id == 'NIC') return featureLayer.on('click', function (e) {
                context.props.history.push("countries/ni");

                if (e) {
                  // eslint-disable-next-line no-console
                  console.log(e.stack);
                }
              });
              return featureLayer.bindPopup("<div class='data-page__section__graph--map__popup-content' style=\"border-color: ".concat(style.color, "\">\n                <div>").concat(feature.properties.name, " is not ready yet! Check back soon!</div>\n                </div>"));
            }
          }).addTo(_this3.state.searchMap);

          _this3.state.searchMapColorOverlays.push(searchMapColorOverlay);
        });
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.initializeSearchMap();
    }
  }, {
    key: "render",
    value: function render() {
      this.props.actions.setBackground('transparent');
      this.props.actions.setColor('gray');

      if (!this.props.countries) {
        return null;
      }

      return React.createElement("div", null, React.createElement(Header, this.props), React.createElement("div", {
        id: "country-search-wrapper",
        className: "country-search-wrapper"
      }, React.createElement("div", {
        ref: "countrySearchMap",
        id: "country-search-map",
        className: "country-search-map"
      }), React.createElement("div", {
        className: "country-search-content"
      }, React.createElement("div", null, React.createElement(CountryDropdown, null, this.props.countries.map(function (country, index) {
        return React.createElement(CountryLink, {
          key: "country-link-".concat(index),
          country: country
        });
      })))), !this.props.isMobileWidth ? React.createElement(Footer, {
        className: "niuera-footer--search-page"
      }) : null), React.createElement(Footer, this.props));
    }
  }]);

  return SearchPage;
}(React.Component);

export { SearchPage as default };
SearchPage.propTypes = {
  countries: PropTypes.func.isRequired,
  actions: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  history: PropTypes.array,
  isMobileWidth: PropTypes.bool.isRequired
};